import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import { ChromePicker } from "react-color";

const useStyles = makeStyles((theme) => ({
  picker: {
    "& .chrome-picker": {
      width: "100% !important",
      boxShadow: "none !important",
      borderRadius: "0 !important",
      background: `${theme.palette.background.paper} !important`,
    },
    "& input": {
      background: `${theme.palette.background.default} !important`,
      color: `${theme.palette.text.primary} !important`,
      boxShadow: "none !important",
      border: `1px solid ${theme.palette.divider} !important`,
      borderRadius: "4px !important",
    },
    "& label": {
      color: `${theme.palette.text.secondary} !important`,
    },
    "& svg": {
      fill: `${theme.palette.text.secondary} !important`,
    },
  },
  actions: {
    padding: "8px 16px 12px",
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

const ColorPicker = ({ onChange, currentColor, handleClose, open }) => {
  const classes = useStyles();
  const [selectedColor, setSelectedColor] = useState(currentColor || "#000000");

  const handleChange = (color) => {
    setSelectedColor(color.hex);
  };

  const handleConfirm = () => {
    onChange(selectedColor);
    handleClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle style={{ paddingBottom: 0 }}>Scegli un colore</DialogTitle>
      <div className={classes.picker}>
        <ChromePicker
          color={selectedColor}
          onChange={handleChange}
          disableAlpha
        />
      </div>
      <DialogActions className={classes.actions}>
        <Button onClick={handleClose}>Annulla</Button>
        <Button onClick={handleConfirm} color="primary" variant="contained">
          Seleziona
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ColorPicker;

